/**
 * Request-photo-upload-policy request validator — SCRUM-147 / DS-011-6.
 *
 * HTTP-boundary Zod schema for the presigned-upload-policy POST payload
 * (`POST /organizations/:slug/properties/:propertyId/media/upload-policy`).
 *
 * The `contentType` allow-set mirrors the `MediaContentType` VO EXACTLY
 * (image/jpeg | image/png | image/webp — case-sensitive, exact membership,
 * NO wildcards / parameters / substring match). The VO remains the
 * authoritative gate inside the use case; this schema yields a clean 400 at
 * the wire boundary before any I/O.
 *
 * `sizeBytes` is bounded to the domain range [10240, 10485760] (10 KB–10 MB,
 * inclusive). This gives a clean 400 at the DTO boundary for the common
 * out-of-range case. The `MediaSizeLimitError` filter mapping (→ 422) is the
 * backstop for any path that still reaches the domain. (SCRUM-147 REQUEST_CHANGES.)
 *
 * `ttlMs` is a positive integer. `filename` is a non-empty string.
 */
import { z } from 'zod';
/** Domain-level size bounds (10 KB–10 MB inclusive). */
const MEDIA_SIZE_MIN_BYTES = 10_240;
const MEDIA_SIZE_MAX_BYTES = 10_485_760;
/** Exact content-type allow-set — mirrors MediaContentType VO (case-sensitive). */
export const MEDIA_UPLOAD_CONTENT_TYPES = [
    'image/jpeg',
    'image/png',
    'image/webp',
];
export const requestPhotoUploadPolicySchema = z.object({
    contentType: z.enum(MEDIA_UPLOAD_CONTENT_TYPES),
    sizeBytes: z
        .number()
        .int()
        .min(MEDIA_SIZE_MIN_BYTES)
        .max(MEDIA_SIZE_MAX_BYTES),
    filename: z.string().min(1),
    ttlMs: z.number().int().positive(),
});
//# sourceMappingURL=request-photo-upload-policy.schema.js.map